import { render, staticRenderFns } from "./ContactFeed.vue?vue&type=template&id=1ca721d6&scoped=true&"
import script from "./ContactFeed.vue?vue&type=script&lang=js&"
export * from "./ContactFeed.vue?vue&type=script&lang=js&"
import style0 from "./ContactFeed.vue?vue&type=style&index=0&id=1ca721d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca721d6",
  null
  
)

export default component.exports